const Form018TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInfo: "申請資料",
        confirmation: "確認",
    },
    label: {
        note: "注意",
        completedByEDB: "此欄由教育局填寫",
    },
    formLabel: {
        refNo: "檔案編號",
        refNo2: "(只供部門使用)",
        name: "申請者姓名",
        name2: "(必須與香港身份證所示者相同)：",
        nameEn: "(英文)",
        nameCn: "(中文)",
        address: "通訊地址 (請以英文填寫)",
        tel: "聯絡電話：",
        contactTelephone: "電話號碼(學校/辦公室)",
        shoolOrOfficeOp: {
            school: "學校電話號碼",
            office: "辦公室電話號碼",
        },
        workTel: "電話號碼",
        homeOrMoblieOp: {
            home: "住宅電話號碼",
            mobile: "手提電話號碼",
        },
        contactTelephoneNo: "電話號碼(住宅/手提)",
        fax: "傳真號碼",
        email: "電郵地址",
        cardLabel: "香港身份證／護照號碼：",
        idCard: "香港身份證",
        passPort: "護照",
        idCardOrpassPortOP: {
            idCard: "香港身份證",
            passPort: "護照",
        },
        registeredOrpermittedOp: {
            registeredT: "檢定教員",
            permittedT: "準用教員",
        },
        shoolOrOrganisationOp: {
            school: "學校",
            organisation: "機構",
        },
        teacher: "檢定教員／准用教員編號：",
        registeredT: "檢定教員編號",
        permittedT: "准用教員編號",
        applicant: "申請人任職的學校／機構名稱及地址：",
        organisation: "機構",
        schoolTypeTitle: "學校類別(如適用)：",
        schoolType: {
            primary: "小學",
            secondary: "中學",
            special: "特殊學校",
        },
        schoolType2: {
            government: "官立",
            aided: "資助",
            dss: "直接資助計劃",
            others: "其他(請加以說明)",
        },
        teachingExperience: "教學經驗：",
        teachingExperienceOp: {
            5: "5年",
            "6–10": "6 – 10年",
            "11–15": "11 – 15年",
            "over 15": "超過15年",
        },
        currentPosition: "目前在學校／機構的職位：",
        analysis: "修畢專業發展需要分析：",
        yesOrNo: {
            yes: "是",
            no: "否",
        },
        certificate: "發出證書日期",
        completion: "修畢擬任校長課程：",
        submittedPortfolioBefore: "曾提交專業發展資料冊：",
        attainedCFP: "曾取得認證：",
        declaration: "聲明",
        termsConditions: "本人謹此聲明，本申請書中所有資料均屬確實無訛。",
        applicantSignature: "申請人簽署",
        date: "日期",
        nil: "提交日期",
        attachmentTooltip: "請附上有關的證書/證明信件的副本。",
        attachment: "附件",
    },
    confirmation: {
        label1: "號碼",
        label2: "申請人任職的",
        label3: "名稱及地址",
        label4: "目前在",
        label5: "的職位",
        label6: "其他",
    },
    importantNotes: {
        note1: "申請者請準備以格式JPG,PNG或PDF的有關文件檔案:",
        note2: "(所有文件的總大小不可超過10MB)",
        note3: "申請者需透過已啟用數碼簽署功能的「智方便」帳戶，以辦理網上遞交申報表。",
        iamSignCheck: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
    },
    errorMsg: {
        ref: "檔案編號",
        nameEn: "姓名(英文)",
        nameCn: "姓名(中文)",
        teacherNo: "教員編號",
        date: "請輸入一個有效的發出證書日期",
    },
};
export default Form018TC;
